/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.clasificaciones': 'Clasificaciones',
  'clasificaciones.agregarClasificaciones': 'Crear Clasificaciones',
  'clasificaciones.modificarClasificaciones': 'Editar Clasificaciones',
  'clasificaciones.clasificacionId': 'Clasificación Id',
  'clasificaciones.empresaId': 'Empresa Id',
  'clasificaciones.clasificacionDescripcion': 'Clasificación Descripción',
  'clasificaciones.VerClasificaciones': 'Ver Clasificaciones',
};
